import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supporters-part',
  templateUrl: './supporters-part.component.html',
  styleUrls: ['./supporters-part.component.css']
})
export class SupportersPartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
